import { render, staticRenderFns } from "./addReserveDiningPerson.vue?vue&type=template&id=d98565f0"
import script from "./addReserveDiningPerson.vue?vue&type=script&lang=js"
export * from "./addReserveDiningPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports